import React, { Component } from 'react'
import { Row, Col, Input, Modal, Table, Select, Button, Popconfirm } from 'antd'
import { app, config, api } from '../../app'
import utils from '../../utils'

const Option = Select.Option

class DonationSign extends Component {
    constructor (props) {
        super(props)
        this.state = {
            signing_status: '3',
            donate_object: '1',
            inquire: '',
            page: 1,
            total: 0,
            dataList: []
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { signing_status, donate_object, inquire } = this.state, params = {
            page,
            inquire,
            signing_status,
            donate_object,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg, total } = await app.post(api.DonateSigningList, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page) {
            this.setData({
                dataList: utils.addArrayKey(data),
                data_loading: false,
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 签收状态变更
     * @param value
     * @returns {Promise<void>}
     */
    handleSignChage = async (value) => {
        await this.setData({ signing_status: value })
        await this.handleData()
    }

    /**
     * 捐赠对象变更
     * @param value
     * @returns {Promise<void>}
     */
    handleObjectChage = async (value) => {
        await this.setData({ donate_object: value })
        await this.handleData()
    }

    handleSearch = async (inquire) => {
        await this.setData({ inquire })
        await this.handleData()
    }

    /**
     * 签收
     * @param id
     */
    handleSign = async (id) => {
        let { flag, msg } = await app.post(api.DonateSigningAudit, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            app.alert('签收成功', 'success')
            await this.handleData(this.state.page)
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 图片预览
     * @param item
     */
    handleRead = (item) => {
        Modal.info({
            title: '捐赠阅览',
            destroyOnClose: true,
            centered: true,
            okText: '确定',
            width: 600,
            content: (
                <div>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠类型</Col>
                        <Col span={18}>{item.donate_type === '1' ? '内部捐赠' : '外部捐赠'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠物品名称</Col>
                        <Col span={18}>{item.goods_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人姓名</Col>
                        <Col span={18}>{item.donate_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人联系方式</Col>
                        <Col span={18}>{item.mobile}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象类型</Col>
                        <Col span={18}>{item.donate_object_type === '1' ? '队伍' : '个人'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象</Col>
                        <Col span={18}>{item.donate_object.object_name}({item.donate_object.object_numbering})</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠数量</Col>
                        <Col span={18}>{item.number}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核人</Col>
                        <Col span={18}>{item.admin_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核状态</Col>
                        <Col
                            span={18}>{item.admin_audit === '0' ? '未审核' : (item.admin_audit === '1' ? '已通过' : '不通过')}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核时间</Col>
                        <Col span={18}>{item.admin_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠时间</Col>
                        <Col span={18}>{item.donate_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>提交时间</Col>
                        <Col span={18}>{item.add_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收人</Col>
                        <Col span={18}>{item.sign_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收状态</Col>
                        <Col span={18}>{item.is_sign === '1' ? '已签收' : '未签收'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收时间</Col>
                        <Col span={18}>{item.sign_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠原因</Col>
                        <Col span={18}>{item.donate_reason || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>物品说明</Col>
                        <Col span={18}>{item.describe || '-'}</Col>
                    </Row>
                    <Row>
                        <Col span={6}>物品图片</Col>
                        <Col span={18}>{item.images.map((img, i) => {
                            return <div style={{ height: 200, textAlign: 'center' }}>
                                <img style={{ width: 'auto', height: 'auto', maxHeight: '100%', maxWidth: '100%' }}
                                     src={config.imgUrl + img} key={i} alt=""/>
                            </div>
                        })}</Col>
                    </Row>
                </div>
            ),
        })
    }

    render () {
        let { data_loading, dataList, total, page } = this.state,
            columns = [
                {
                    title: '捐赠类型',
                    dataIndex: 'donate_type',
                    key: 'donate_type',
                    width: '8%',
                    render (donate_type) {
                        return donate_type === '1' ? '内部捐赠' : (donate_type === '2' ? '外部捐赠' : '未知')
                    }
                },
                {
                    title: '捐赠对象类型',
                    dataIndex: 'donate_object_type',
                    key: 'donate_object_type',
                    width: '8%',
                    render (donate_type) {
                        return donate_type === '1' ? '队伍' : (donate_type === '2' ? '个人' : '未知')
                    }
                },
                {
                    title: '捐赠对象',
                    dataIndex: 'donate_object',
                    key: 'donate_object',
                    width: '15%',
                    render ({ object_name, object_numbering }) {
                        return <span>
                        <div>{object_name}</div>
                        <div>({object_numbering})</div>
                    </span>
                    }
                },
                {
                    title: '捐赠物品',
                    dataIndex: 'goods_name',
                    key: 'goods_name',
                    width: '15%'
                },
                {
                    title: '捐赠阅览',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '10%',
                    render: (donate_reason, item) => {
                        return <div style={{ color: '#3399CC', cursor: 'pointer' }}
                                    onClick={() => this.handleRead(item)}>捐赠阅览</div>
                    }
                },
                {
                    title: '捐赠数量',
                    dataIndex: 'number',
                    key: 'number',
                    width: '8%'
                },
                {
                    title: '捐赠时间',
                    dataIndex: 'donate_time',
                    key: 'donate_time',
                    width: '15%'
                },
                {
                    title: '捐赠人',
                    dataIndex: 'donate_name',
                    key: 'donate_name',
                    width: '11%',
                    render (donate_name, { mobile }) {
                        return (<span>
                                    <div>{donate_name}</div>
                                    <div>({mobile})</div>
                                </span>)
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '10%',
                    render: (id, { is_sign }) => {
                        if (is_sign === '1') {
                            return '已签收'
                        } else {
                            return (
                                <Popconfirm title="确定签收吗？" onConfirm={() => this.handleSign(id)} okText="确定"
                                            cancelText="取消">
                                    <Button type="primary">签收</Button>
                                </Popconfirm>
                            )
                        }
                    }
                },
            ]
        return (
            <div className="donation">
                <h1 className="donation-title">捐赠签收</h1>
                <div className="donation-content">
                    <div className="filter">
                        <Select defaultValue="3" style={{ width: 120 }} onChange={this.handleSignChage}>
                            <Option value="1">全部</Option>
                            <Option value="2">已签收</Option>
                            <Option value="3">未签收</Option>
                        </Select>
                        <Select defaultValue="1" style={{ width: 120, margin: '0 20px' }}
                                onChange={this.handleObjectChage}>
                            <Option value="1">全部</Option>
                            <Option value="2">队伍</Option>
                            <Option value="3">个人</Option>
                        </Select>
                        <Input.Search
                            style={{ width: 360 }}
                            placeholder="输入捐赠人完整的手机号或姓名查询"
                            enterButton="搜索"
                            onSearch={this.handleSearch}
                        />
                    </div>
                    <Table columns={columns}
                           locale={app.tbLocale(data_loading)}
                           dataSource={dataList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 90px)' }}
                           className="donation_table"
                           pagination={{
                               total,
                               pageSize: 20,
                               current: page,
                               showTotal: (total) => `总数量：${total}`,
                               onChange: this.handleData
                           }}
                           footer={() => (
                               <span style={{ color: 'red' }}>注：捐赠对象为个人的由个人进行签收，捐赠对象为队伍的由管理员进行签收。</span>
                           )}
                           size="small"
                    />
                </div>
            </div>
        )
    }
}

export default DonationSign



// WEBPACK FOOTER //
// ./src/routes/donation/DonationSign.jsx